import { lazy } from 'react';
import ProtectedRoute from '../../../core/accessControl/ProtectedRoute';
import PlatformModules from '../../../core/accessControl/Modules';
import LockAlmanac from '../components/LockAlmanac';

const Almanac = lazy(() => import('../pages/almanac'));

const almanacModule = [PlatformModules.ALMANAC.ID]

export const AlmanacRoutes = [
  {
    path: '',
    element: <ProtectedRoute
      modulesAllowed={almanacModule}
      element={<Almanac />}
      customLock={<LockAlmanac />}
    />
  }
];
